/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { get } from '../../services/GenesisApi';
import { IZkeyMapping } from '../../types/BeachSwaps.type';
import { sendNotification } from '../../UI/Notification';
import { MESSAGES } from '../../constants/BeachSwaps';

type GetCounterPartyType = (
  id: number | null,
  type: 'add' | 'edit' | null
) => {
  loadingZkeyInformation: boolean;
  zkeyInformation: IZkeyMapping | null;
};

const useGetZkeyInformation: GetCounterPartyType = (
  id: number | null,
  type: 'add' | 'edit' | null
) => {
  const [loading, setLoading] = useState(false);
  const [zKeyData, setZKeyData] = useState<IZkeyMapping | null>(null);

  useEffect(() => {
    if (id && type === 'edit') {
      setLoading(true);
      get(`/api/BeachSwap/GetBeachSwapMappingById?mappingId=${id}`)
        .then((response) => {
          setZKeyData(response.data ?? null);
        })
        .catch(() => {
          sendNotification({
            type: 'error',
            message: MESSAGES.SERVER_ERROR,
          });
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  return {
    loadingZkeyInformation: loading,
    zkeyInformation: zKeyData,
  };
};

export default useGetZkeyInformation;
